import {
  Home as HomeIcon,
  HeartPulse,
  Briefcase,
  ShieldCheck,
  HandHeart,
  BookOpen,
  School,
  Smile,
  Leaf,
} from "lucide-react";

export const ICONS = {
  Home: HomeIcon,
  HeartPulse,
  Briefcase,
  ShieldCheck,
  HandHeart,
  BookOpen,
  School,
  Smile,
  Leaf,
};
